<template>
  <ion-card
    class="no-shadow rental-card ion-no-margin pa-xs w-100"
    :class="{ 'bg-white': isRead, 'bg-blue-tint': !isRead }"
    color="light"
    @click="$emit('click-notification')"
  >
    <div class="d-flex justify-space-between">
      <div class="d-flex">
        <ion-icon color="grey" :icon="getIcon" size="large"></ion-icon>

        <div class="padding-list-item">
          <p class="bold-medium font-sm hide">
            {{ title }}
          </p>
          <p class="nowrap grey">{{ formatDateTime(createdAt, locale, true, true) }}</p>
        </div>
      </div>
      <div v-if="!isRead" class="notification-badge"></div>
    </div>
  </ion-card>
</template>

<script setup lang="ts">
  import { formatDateTime } from '@/utils/date-utils';
  import { IonCard, IonIcon } from '@ionic/vue';
  import { checkmarkCircleOutline, closeOutline } from 'ionicons/icons';
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  const { locale } = useI18n();
  const reservationWords = ['rejected', 'canceled', 'cancelada', 'rechazada'];

  const props = withDefaults(
    defineProps<{
      title: string;
      createdAt: string;
      isRead: boolean;
      type: string;
    }>(),
    {
      title: '',
      createdAt: '',
      isRead: false,
      type: '',
    },
  );

  const getIcon = computed(() => {
    if (props.type === 'reservations') {
      const findRejected = reservationWords.some((word) => props.title.includes(word));

      return findRejected ? closeOutline : checkmarkCircleOutline;
    }
    return checkmarkCircleOutline;
  });
</script>

<style lang="css" scoped>
  .hide {
    width: 220px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  ion-card {
    cursor: pointer;
  }
</style>
